module.exports = __webpack_public_path__ + "static/media/gc-partenon-end.53a78ea6.png";